import { EQUAL_WEIGHTS_TITLE } from '../../../../../../../../../../common/model/input/value-sets';
import { useNetScore } from '../../../context';
import { NetScoreBlock } from './index';

interface Props {
  onContributeClick?: () => void;
}

export function NetScoreBlockEqualWeights(_props: Props) {
  const netScore = useNetScore(0);
  return <NetScoreBlock value={netScore} valueSetName={EQUAL_WEIGHTS_TITLE} />;
}
